"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _primaryCustomerDataActions = require("../actions/primaryCustomerDataActions");

function primaryCustomer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _primaryCustomerDataActions.PRIMARY_CUSTOMER_DATA_RECEIVED:
            return action.primaryCustomerData;
        default:
            return state;
    }
}

exports.default = primaryCustomer;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/primaryCustomer.js
// module id = 1400
// module chunks = 0